import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46125fad"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "row gx-2 align-items-center" }
const _hoisted_3 = {
  key: 0,
  class: "col-auto"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fs-3" }, "chevron_left", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "col" }
const _hoisted_7 = { class: "d-flex align-items-center" }
const _hoisted_8 = {
  key: 0,
  class: "badge bg-warning fs-6 ms-3"
}
const _hoisted_9 = {
  key: 1,
  class: "badge bg-info fs-6 ms-3"
}
const _hoisted_10 = { class: "col-auto" }
const _hoisted_11 = { class: "buttons" }
const _hoisted_12 = {
  key: 1,
  class: "col-auto"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mas fw-light" }, "refresh", -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mas fw-light" }, "help", -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = ["id"]
const _hoisted_18 = { class: "offcanvas-header" }
const _hoisted_19 = {
  class: "offcanvas-title",
  id: "offcanvasHelpText"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "offcanvas",
  "aria-label": "Close"
}, null, -1))
const _hoisted_21 = { class: "offcanvas-body" }
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = {
  type: "button",
  class: "btn btn-light mt-5",
  "data-bs-dismiss": "offcanvas"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass('col-xxl-' + this.col)
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["base-title", 'mb-' + this.mb])
        }, [
          _createElementVNode("div", _hoisted_2, [
            (this.backRoute||this.useRouterBack)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("button", {
                    class: "btn btn-hover",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                  }, _hoisted_5)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h1", _hoisted_7, [
                _createTextVNode(_toDisplayString(this.title) + " ", 1),
                _renderSlot(_ctx.$slots, "icons", {}, undefined, true),
                (this.isLibrary)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.$t('library')), 1))
                  : _createCommentVNode("", true),
                (this.mode)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.$t(this.mode.toLowerCase())), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _renderSlot(_ctx.$slots, "buttons", {}, undefined, true)
              ])
            ]),
            (this.showRefreshButton || this.helpText)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  (this.showRefreshButton)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: "javascript:void(0)",
                        class: "btn btn-hover",
                        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (this.$emit('refresh')), ["prevent"]))
                      }, _hoisted_14))
                    : _createCommentVNode("", true),
                  (this.helpText)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        href: "javascript:void(0)",
                        class: "btn btn-hover",
                        onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (this.openHelpOffcanvas && this.openHelpOffcanvas(...args)), ["prevent"]))
                      }, _hoisted_16))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])
        ], 2)
      ], 2)
    ]),
    (this.helpText)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          id: this.helpOffcanvasId,
          class: "offcanvas offcanvas-end",
          tabindex: "-1",
          "aria-labelledby": "offcanvasHelpText"
        }, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("h5", _hoisted_19, _toDisplayString(this.title), 1),
            _hoisted_20
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", {
              innerHTML: this.helpText
            }, null, 8, _hoisted_22),
            _createElementVNode("button", _hoisted_23, _toDisplayString(_ctx.$t('close')), 1)
          ])
        ], 8, _hoisted_17))
      : _createCommentVNode("", true)
  ], 64))
}